export function capitalizeFirstLetter(string: string) {
  if (!string || !string.length) {
    return '';
  }
  const toString = string.toString();
  return toString.charAt(0).toUpperCase() + toString.slice(1);
}

export const isString = (val: any) => typeof val === 'string' || val instanceof String;

export const sanitizeTitle = (title: string) => title.replace(/&amp;/g, '&');

export function truncateString(str: string, maxCharsIncSpaces: number, maxCharsExSpaces?: number): string {
  let trimmed: string = str;
  const _maxCharsExSpaces = maxCharsExSpaces ?? maxCharsIncSpaces;

  if (trimmed.replace(/\s/g, '').length > _maxCharsExSpaces) {
    let count = 0;
    trimmed = trimmed
      .split('')
      .filter((char) => {
        if (char !== ' ') count++;
        return count <= _maxCharsExSpaces;
      })
      .join('');
  }

  return trimmed.length > maxCharsIncSpaces ? trimmed.slice(0, maxCharsIncSpaces - 1) + '...' : trimmed;
}

export function decodeUnicodeString(input: string) {
  const isEncoded = /\\u[\dA-F]{4}/i.test(input);

  if (!isEncoded) {
    return input;
  }

  return input.replace(/\\u[\dA-F]{4}/gi, function (match) {
    return String.fromCharCode(parseInt(match.replace(/\\u/, ''), 16));
  });
}

export function restoreUnicodeCharacters(input: string) {
  const textarea = document.createElement('textarea');
  textarea.innerHTML = input;
  return textarea.value;
}
